import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import ProductGridSingle from "../../components/product/ProductGridSingle";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import { fetchFeaturedProducts,fetchFeaturedGroupProducts, isLoading } from "../../redux/actions/featureProductActions"
import { AuthContext } from "../../common/Auth"
import axios from 'axios'
import { USER_GROUPS, X_TENANT_ID } from "../../common/ActionUrl";
import { getISODate } from "../../common/DateFomatter";
let apiCount = 0;
function timeOut(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms) )
}
const ProductGrid = ({
   fetchFeaturedProducts,
   fetchFeaturedGroupProducts,
   featuredProducts,
   currency,
   addToCart,
   addToWishlist,
   addToCompare,
   cartItems,
   wishlistItems,
   compareItems,
   sliderClassName,
   spaceBottomClass,
   ownProps,
   limit,
   isLoading,
   loading
  }) => {
  
  const { themeSettingsData, userPoints, login,userGroupDiscount, categoriesList } = useContext(AuthContext)
  const [toggle, setToggle] = useState(true)

  useEffect(() => {
    getUserGroupCategories()
  }, [])

  const getUserGroupCategories = async() => {
    let data = {}
    const requestOptions = {
      headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
    }
    let userCat = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : ''

    if (userCat && userCat != "") {
      axios
        .get(USER_GROUPS + userCat.userId, requestOptions)
        .then(async (res) => {
          if (res.data) {
            let getUserGroup = res.data['userGroups']
            if (getUserGroup && getUserGroup.length > 0) {
              data = {
                id: userCat?.userId
              }
              await fetchFeaturedGroupProducts(limit, 0, 'productName', 'asc', data)
            } else {
              data.isFeatured = true
              callProducts(data)
            }
          } else {
            data.isFeatured = true
            callProducts(data)
          }
        })
        .catch((err) => console.log(err))

    } else {
      data.isFeatured = true
      callProducts(data)
    }
  }

  const callProducts = async(data) => {
    isLoading(true);
    await fetchFeaturedProducts(limit, 0, 'productName', 'asc', data);
  }

  useEffect(() => {
    setToggle(!toggle)
  }, [featuredProducts])

  return (
    <Fragment>
      {featuredProducts && featuredProducts.map(product => {
        product.startDate  = getISODate(product?.startDate);
        product.endDate  = getISODate(product?.endDate);
        return (
          <ProductGridSingle
            limit = {limit}
            setToggle={setToggle}
            toggle={toggle}
            sliderClassName={sliderClassName}
            spaceBottomClass={spaceBottomClass}
            product={product}
            currency={currency}
            addToCart={addToCart}
            addToWishlist={addToWishlist}
            addToCompare={addToCompare}
            cartItem={
              cartItems?.filter(cartItem => cartItem.id === product.id)?.[0]
            }
            wishlistItem={
              wishlistItems.filter(
                wishlistItem => wishlistItem.id === product.id
              )[0]
            }
            compareItem={
              compareItems.filter(
                compareItem => compareItem.id === product.id
              )[0]
            }
            key={product.id}
			isFeature={true}
          />
        );
      })}
    </Fragment>
  );
};

ProductGrid.propTypes = {
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  products: PropTypes.array,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  wishlistItems: PropTypes.array
};

const mapStateToProps = (state, ownProps) => {
  return {
    featuredProducts:
        state.featureProductData.featuredProducts,
    ownProps: ownProps,
    currency: state.currencyData,
    cartItems: state.cartData.cartItems,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData,
    loading: state.productData.loading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (
      item,
      _addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize,
      selectedProductDecorations,
      personalizationArray,
      personalizationCost,
      userGroupDiscount
    ) => {
      dispatch(
        addToCart(
          item,
          _addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize,
          selectedProductDecorations,
          personalizationArray,
          personalizationCost,
          userGroupDiscount
        )
      );
    },
    addToWishlist: (item, _addToast, wishlistRelabel = 'Wishlist') => {
      dispatch(addToWishlist(item, _addToast, wishlistRelabel));
    },
    addToCompare: (item, _addToast) => {
      dispatch(addToCompare(item, _addToast));
    },
    fetchFeaturedProducts: (limit, offset, order, orient, filter) => {
      dispatch(fetchFeaturedProducts(limit, offset, order, orient, filter));
    },
    fetchFeaturedGroupProducts: (limit, offset, order, orient, filter) => {
      dispatch(fetchFeaturedGroupProducts(limit, offset, order, orient, filter));
    },
    isLoading: (loading) => {
      dispatch(isLoading(loading));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGrid);
